
    <button type="button" class="btn btn-primary btn-sm" (click)="edit()" style="font-size: 12px;width: 40px;" data-toggle="tooltip" title="Edit Patient"> <i class="far fa-edit"></i> 
    </button>
    &nbsp;&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="delete()" style="font-size: 12px;width: 40px;" data-toggle="tooltip" title="Delete Patient"> <i class="far fa-trash"></i>
    </button>


